<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->
<div
	class="ticket-type-shape-container"
	[ngClass]="{ focused: cycleSelected, selected: selected && !cycleSelected }"
>
	<ticket-thumbnail
		[ticketType]="ticketType"
		[isComplete]="actualFinish"
		[isStarted]="!actualFinish && actualStart"
		[ticketRole]="liveRole"
	>
	</ticket-thumbnail>
	<ticket-promise-icon
		class="pin-section"
		[totalPins]="livePromisePeriodStack ? livePromisePeriodStack.length : 0"
		[missedCount]="livePromisePeriodStack ? livePromisePeriodStack.length - 1 : 0"
		[color]="
			livePromisePeriodStack
				? livePromisePeriodStack[livePromisePeriodStack.length - 1].data.color
				: '#000000'
		"
		[ticketType]="selectedType"
	></ticket-promise-icon>
</div>
<div class="ticket-item-container">
	<span class="title-section" automationId="ticketSection">
		{{ activityName }}
	</span>
	<div class="date-section">{{ dateCache.ticketDateStringConvert(liveStart, liveFinish, true) }}</div>
	<div class="counts-section" *ngIf="liveCrewSize">
		<div class="count-item" automationId="liveCrewSize">
			<mat-icon class="count-icons"> people </mat-icon>
			{{ liveCrewSize }}
		</div>
		<div class="count-item" *ngIf="liveDurationDays">
			<mat-icon class="count-icons" automationId="liveDurationDays"> date_range </mat-icon>
			{{ liveDurationDays }}
		</div>
	</div>
	<div class="role-section" automationId="RoleName">{{ liveRole?.view.roleName }}</div>
	<div class="location-section" automationId="locationName">{{ locationName }}</div>
</div>
